import React from 'react'
import BaseInput from '../../General/FormsComp/Input/BaseInput'

const ComercialCadastro = ({newClient, handleInputChange}) => {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <BaseInput
                label="Nome Prefeito"
                name="nome_prefeito"
                value={newClient?.nome_prefeito}
                onChange={handleInputChange}
                type="text"
            />
            
            <BaseInput
                label="Nome Vice-prefeito"
                name="nome_vice_prefeito"
                value={newClient?.nome_vice_prefeito}
                onChange={handleInputChange}
                type="text"
            />
            
            <BaseInput
                label="Nome Secretário(a) Administração"
                name="nome_secretario_adm"
                value={newClient?.nome_secretario_adm}
                onChange={handleInputChange}
                type="text"
            />
            
            <BaseInput
                label="E-mail Secretario(a) Administração"
                name="email_secretario_adm"
                value={newClient?.email_secretario_adm}
                onChange={handleInputChange}
                type="email"
            />
            
            <BaseInput
                label="Telefone Secretário(a)"
                name="telefone_secretario_adm"
                value={newClient?.telefone_secretario_adm}
                onChange={handleInputChange}
                type="tel"
            />

            <BaseInput
                label="Nome do Contato"
                name="nome_contato_comercial"
                value={newClient?.nome_contato_comercial}
                onChange={handleInputChange}
                type="text"
            />
            
            <BaseInput
                label="Telefone"
                name="telefone_comercial"
                value={newClient?.telefone_comercial}
                onChange={handleInputChange}
                type="tel"
            />
            
            <BaseInput
                label="Email"
                name="email_comercial"
                value={newClient?.email_comercial}
                onChange={handleInputChange}
                type="email"
            />
            
            <BaseInput
                label="Setor"
                name="setor_comercial"
                value={newClient?.setor_comercial}
                onChange={handleInputChange}
                type="text"
            />
    </div>
  )
}

export default ComercialCadastro
